import { render, staticRenderFns } from "./calendar-modal-workout.vue?vue&type=template&id=5ed2fe09&"
import script from "./calendar-modal-workout.vue?vue&type=script&lang=js&"
export * from "./calendar-modal-workout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports